import { AUCTION_PAGE_ROUTE } from 'utils/constants/app';

import { VacancyId } from 'store/models/mainMenu';

/** Округляет число в большую сторону, например
 * roundUpTo(2344, 10) => 2350
 * roundUpTo(2344, 100) => 2400
 * */
export const roundUpTo = (value: number, to: number): number => {
    return Math.ceil(value / to) * to;
};

/** Возвращает минимальный бюджет в зависимости от прошлого бюджета, ставки и остатка
 * Новый бюджет должен быть кратен 100 и его должно хватать хотя бы на 1 ставку.
 * (считаем что кратен 10000, так как всё храним в копейках)
 * */
export const getAuctionRestoreBudgetMinValue = (
    currentBudget: number,
    unspentCampaignBudget: number,
    bid: number
): number => {
    return roundUpTo(currentBudget - unspentCampaignBudget + bid, 10000);
};

export const getAuctionEditUrl = (vacancyId: VacancyId): string =>
    AUCTION_PAGE_ROUTE.replace(':vacancyId', String(vacancyId));

export const getAudienceFillRateStyle = (value: number): 'negative' | 'warning' | 'positive' => {
    const NEGATIVE_PERCENTAGE_LIMIT = 50;
    const WARNING_PERCENTAGE_LIMIT = 80;

    if (value < NEGATIVE_PERCENTAGE_LIMIT) {
        return 'negative';
    }
    if (value < WARNING_PERCENTAGE_LIMIT) {
        return 'warning';
    }
    return 'positive';
};
